import React from "react";
import { useTranslation } from "react-i18next";
import MemberCard from "./MemberCard";

export default function MemberList({
  members,
  onRemoveMember,
  onEditMember,
  canEdit = true,
  maxMembers,
  setTeam,
  isSupervisor,
}) {
  const [t] = useTranslation();

  if (members.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium mb-4">
        {t("team.members")} ({members.length}/{maxMembers})
      </h3>
      <div className="space-y-3">
        {members.map((member) => (
          <MemberCard
            key={member.uuid}
            member={member}
            onRemove={() => onRemoveMember(member.uuid)}
            onEdit={onEditMember}
            canEdit={canEdit}
            isSupervisor={isSupervisor}
            setTeam={setTeam}
          />
        ))}
      </div>
    </div>
  );
}
